/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./luckylotteryitems.vue?vue&type=template&id=0dda77f8&scoped=true"
import script from "./luckylotteryitems.vue?vue&type=script&lang=js"
export * from "./luckylotteryitems.vue?vue&type=script&lang=js"
import style0 from "./luckylotteryitems.vue?vue&type=style&index=0&id=0dda77f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dda77f8",
  null
  
)

export default component.exports